var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28293D",
    d: "M.767 6.855h14.467c.135 0 .244-.12.237-.255-.041-.8-.14-1.354-.38-1.823a3.75 3.75 0 0 0-1.638-1.639c-.402-.205-.867-.307-1.494-.358v-1.3a.625.625 0 0 0-1.25 0v1.254A109.89 109.89 0 0 0 9.5 2.73h-3c-.451 0-.846.001-1.208.005V1.48a.625.625 0 0 0-1.25 0V2.78c-.627.051-1.092.153-1.494.358A3.75 3.75 0 0 0 .909 4.777C.67 5.247.571 5.801.53 6.6a.243.243 0 0 0 .238.255ZM15.5 8.813a.708.708 0 0 0-.709-.709H1.21a.708.708 0 0 0-.709.709v3.333c0 2.1 0 3.15.409 3.953a3.75 3.75 0 0 0 1.639 1.638c.802.409 1.852.409 3.952.409h3c2.1 0 3.15 0 3.953-.409A3.75 3.75 0 0 0 15.09 16.1c.409-.803.409-1.853.409-3.953V8.813ZM5.083 15.229a.833.833 0 1 1 0-1.666.833.833 0 0 1 0 1.666Zm0-2.916a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667ZM8 15.229a.833.833 0 1 1 0-1.666.833.833 0 0 1 0 1.666Zm0-2.916a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Zm2.917 2.916a.833.833 0 1 1 0-1.666.833.833 0 0 1 0 1.666Zm0-2.916a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSolid);
export default __webpack_public_path__ + "static/media/calendar-solid.0f78f5511a7559186ef3cd616a3b79d8.svg";
export { ForwardRef as ReactComponent };